// extracted by mini-css-extract-plugin
export var settingsList = "_2x-0";
export var settingsRow = "_2x-1";
export var warningDot = "_2x-2";